import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QualityareamasterService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

constructor(private http: HttpClient) { }

saveQualityMasterArea(data: any): Observable<any> {
  return this.http.post<any>(this.baseUrl + 'QualityMasterAreas/SaveQualityMasterArea', data);
}

searchQualityMasterAreas(data: any): Observable<any> {
  return this.http.post<any>(this.baseUrl + 'QualityMasterAreas/SearchQualityMasterAreas', data);
}

deleteQualityMasterArea(data: any): Observable<any> {
  return this.http.post<any>(this.baseUrl + 'QualityMasterAreas/DeleteQualityMasterArea', data);
}

}
